import { render, staticRenderFns } from "./ClientNotificationTable.vue?vue&type=template&id=779af29f&"
import script from "./ClientNotificationTable.vue?vue&type=script&lang=js&"
export * from "./ClientNotificationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports